/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { AppSettings } from '../../app.settings';
import { Validators, UntypedFormBuilder, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { UserCommonService } from '../../services/user-common.service';
import { UiService } from '../../services/ui.service';
import { ToastMessageOptions } from 'primeng/api';
import { Subscription } from 'rxjs';
import { CommonMessageTransferService } from '../../services/common-message-transfer.service';
import { ErrorDto } from '../../models/error-dto';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    standalone: false
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {

  @Output() popClose: EventEmitter<any> = new EventEmitter();
  @Output() popSave: EventEmitter<any> = new EventEmitter();
  forgotPasswordErrors = [
    {
      username: false
    }
  ];
  message: ToastMessageOptions[] = [];
  subscription: Subscription;
  submitOnce = false;
  editforgotForm = new UntypedFormGroup({
    username: new UntypedFormControl()
  });



  constructor(
    private formBuilder: UntypedFormBuilder,
    private commonServices: UserCommonService,
    private uiService: UiService,
    private commonMessageTransferService: CommonMessageTransferService,
  ) { }

  ngOnInit() {
    this.editforgotForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.pattern(AppSettings.EMAIL_PATTERN)]],
    });

    this.subscription = this.commonMessageTransferService.restAPIGeneralErrorEvent.subscribe(
      (error: ErrorDto) => {
        this.submitOnce = false;
        this.uiService.showMessage(error.message, AppSettings.MESSAGE_TYPE.ERROR);
      }
    );
  }

  closeEditForgot() {
    this.editforgotForm.reset();
    this.popClose.emit();
  }

  changePassword() {
    this.submitOnce = true;
    this.message = [];
    let input;
    let otpEmail;
    if (this.editforgotForm.valid) {

      const userName = this.editforgotForm.controls.username.value;
      if (userName.match(AppSettings.EMAIL_PATTERN)) {
        otpEmail = userName;
        input = {
          email: userName.trim().toLowerCase().trim(),
        };
      } else if (userName.match(AppSettings.PHONE_PATTERN)) {
        input = {
          phoneNum: userName,
        };
      } else {
        input = {
          username: userName,
        };
      }
      this.commonServices.forgotPassword(JSON.stringify(input)).subscribe({
        next: (results) => {
        results.email = otpEmail;
        this.popSave.emit(results);
        this.editforgotForm.reset();
        this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
        this.submitOnce = false;
      },
      error: (error) => {
        console.log(error);
      }
      });
    } else {
      this.editforgotForm.markAllAsTouched();

    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
